import React, { Fragment } from 'react'
import OurTeamComponent from '../components/our_team_v2/our_team_component';
import PageHelmet from '../components/common/PageHelmet';

export default function OurTeamScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Our Team - Rubaai Digital Payment Solutions"
                description="Meet the talented team behind Rubaai's innovative digital payment solutions. Our experts are dedicated to revolutionizing the way people transact in the digital world."
                keywords="Rubaai team, digital payment experts, fintech professionals, payment technology team, company leadership, team members"
            />
            <OurTeamComponent />
        </Fragment>
    );
}
